import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable"; // 👈 This line is critical

import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import {
  exportToExcel,
  exportToPdf,
  exportToWord,
} from "../../utils/exportUtils";

const DownloadData = ({ tableData, headers, fileName }) => {
  const [downloadFormat, setDownloadFormat] = useState("");

  const handleDownload = () => {
    if (!downloadFormat) {
      alert("Please select a download format.");
      return;
    }
    if (!tableData || tableData.length === 0) {
      alert("No data available to export");
      return;
    }

    if (downloadFormat === "pdf") {
      exportToPdf(headers, tableData, fileName);
    } else if (downloadFormat === "excel") {
      exportToExcel(headers, tableData, fileName);
    } else if (downloadFormat === "word") {
      exportToWord(headers, tableData, fileName);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: 2,
        my: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          width: "100%",
          gap: 2,
        }}
      >
        <FormControl
          variant="outlined"
          sx={{
            width: "180px",
            mr: "10px",
            "& .MuiOutlinedInput-root": {
              height: 44,
              borderRadius: "8px",
              backgroundColor: "#fff",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#888",
            },
            "& .MuiInputLabel-outlined": {
              transform: "translate(14px, 9px) scale(1)",
            },
            "& .MuiInputLabel-shrink": {
              transform: "translate(14px, -6px) scale(0.75)",
              backgroundColor: "#fff",
              padding: "0 4px",
            },
          }}
        >
          <InputLabel>Export Format</InputLabel>
          <Select
            value={downloadFormat}
            onChange={(e) => setDownloadFormat(e.target.value)}
            label="Export Format"
            MenuProps={{
              PaperProps: {
                sx: {
                  borderRadius: "8px",
                  mt: 1,
                },
              },
            }}
          >
            <MenuItem value="pdf">PDF</MenuItem>
            <MenuItem value="excel">Excel</MenuItem>
            <MenuItem value="word">Word</MenuItem>
          </Select>
        </FormControl>

        <Button
          variant="outlined"
          color="primary"
          onClick={handleDownload}
          sx={{
            borderRadius: "8px",
            padding: "8px 16px",
            border: "1px solid #1976d2",
            backgroundColor: "#1994d2",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#1565c0",
              borderColor: "#1565c0",
            },
          }}
        >
          Download
        </Button>
      </Box>
    </Box>
  );
};

export default DownloadData;
